<div class="dialog-wrapper">
  <bms-common-title-section
    [icon]="icon"
    [title]="title"
    [subTitle]="subTitle"
  ></bms-common-title-section>

  <div class="dialog-scrollable-content">
    <ng-content></ng-content>
  </div>

  <bms-common-popup-footer
    [cancelTitle]="cancelTitle"
    [submitTitle]="submitTitle"
    [isCancelEnabled]="isCancelEnabled"
    [isSubmitEnabled]="isSubmitEnabled"
    (onCancelClick)="onClickCancel($event)"
    (onSubmitClick)="onClickSubmit($event)"
  >
  </bms-common-popup-footer>
</div>
